import { motion } from 'framer-motion'

export default function PageHeader({ title, subtitle, category = 'PACIEH Initiative', className = '' }) {
  return (
    <div className={`bg-forest text-white py-20 pt-28 relative overflow-hidden shadow-sm ${className}`}>
      {/* Decorative subtle ambient circle */}
      <div className="absolute -top-32 -right-32 w-80 h-80 bg-[#165a39] rounded-full blur-3xl opacity-40 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          {category && (
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider text-[#8de058] mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#8de058]" />
              {category}
            </div>
          )}

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black font-display tracking-tight leading-[1.05] text-white">
            {title}
          </h1>

          {subtitle && (
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/85 max-w-2xl font-normal">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  )
}